<template>
    <div class="mt-2">
        <v-overlay :model-value="loading"
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row class="mb-2">
            <v-col md="2" sm="12">
                <v-card variant="flat" class="pa-4 my-2" color="blue-grey-darken-1">
                    <h4>FILTERS</h4>
                    <div v-for="filter in filters" :key="filter.status" class="mb-2">
                        <v-btn block :variant="filter.status == activeFilter ? 'flat': 'outlined'" :active="filter.status == activeFilter" href="#" @click="filterJobs(filter.status)">{{warrantyDescription(filter.status).title}} ({{filter.count}})</v-btn>
                    </div>
                </v-card>
            </v-col>
            <v-col md="10" sm="12">
                <v-card variant="flat" class="pa-4 my-2">
                    <h3>Warranties Needing Attention</h3>
                    <div>
                        <v-text-field label="Search..."
                                      prepend-icon="mdi-magnify"
                                      v-model="searchTerm"
                                      density="compact"
                                      clearable></v-text-field>
                    </div>
                    <v-table>
                        <thead>
                            <tr>
                                <th style="width:8%">Job</th>
                                <th style="width:18%">Cust#</th>
                                <th style="width:18%">Customer</th>
                                <th style="width:8%">Warranty Status</th>
                            </tr>
                        </thead>
                        <tbody v-if="data">
                            <tr v-for="job in filteredJobs" :key="job.id">
                                <td>
                                    <job-link :job="job" :search-term="searchTerm"></job-link>
                                </td>
                                <td>
                                    <span v-html="formatSearchName(job.customerNumber, searchTerm)"></span>
                                </td>
                                <td>
                                    <contact-link :contact="job.contact" :search-term="searchTerm"></contact-link>
                                </td>
                                <td>
                                    <warranty-type-chip :status="job.warrantyStatus"></warranty-type-chip>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { formatSearchName } from "../../mixins/searchMixins";
    function initialState() {
        return {
            loading: false,
            data: [],
            filters: [],
            activeFilter: null
        };
    }
    export default {
        name: "WarrantyDashboard",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
        },
        props: {
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "updateSmartJobStatus"
            ]),
            formatSearchName,
            numberWithCommas,
            loadData() {
                this.loading = true;
                this.$api.get('/dashboard/warranty')
                    .then(res => {
                        this.data = res.data.jobs;
                        this.filters = res.data.filters;
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("There was an issue getting the jobs.");
                    });
            },
            warrantyDescription(status) {
                return this.$constants.jobs.warrantyStatuses[status];
            },
            filterJobs(status) {
                if (this.activeFilter === status) {
                    this.activeFilter = null;
                } else {
                    this.activeFilter = status;
                }
            }
        },
        computed: {
            filteredJobs() {
                if (this.data && this.data) {
                    let jobs = this.data;
                    if (this.searchTerm && this.searchTerm.length > 0) {
                        let upperSearch = this.searchTerm.toUpperCase();
                        jobs = jobs.filter(item => {
                            return item.customerNumber.toUpperCase().includes(upperSearch) || item.name.toUpperCase().includes(upperSearch) || item.contact.name.toUpperCase().includes(upperSearch);
                        });
                    }
                    if (this.activeFilter) {
                        jobs = jobs.filter(item => item.warrantyStatus == this.activeFilter);
                    }
                    return jobs;
                }
                return [];
            },
        },
        watch: {
        }
    };
</script>
<style scoped>
</style>